// Function to close all nested dropdowns
function closeAllNestedDropdowns() {
  document.querySelectorAll('.nested-dropdown__trigger[aria-expanded="true"]').forEach(function(trigger) {
    const targetId = trigger.getAttribute('aria-controls');
    const targetMenu = document.getElementById(targetId);
    const icon = trigger.querySelector('.icon');
    
    if (targetMenu) {
      targetMenu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      
      if (icon) {
        icon.classList.remove('is-active');
      }
    }
  });
}

// Handle nested dropdown clicks
document.querySelectorAll('.nested-dropdown__trigger').forEach(function(toggle) {
  toggle.addEventListener('click', function(event) {
    event.preventDefault();
    
    const targetId = this.getAttribute('aria-controls');
    const targetMenu = document.getElementById(targetId);
    const icon = this.querySelector('.icon');

    if (targetMenu) {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      
      targetMenu.hidden = !targetMenu.hidden;
      
      this.setAttribute('aria-expanded', !isExpanded);

      if (icon) {
        if (!isExpanded) {
          icon.classList.add('is-active');
        } else {
          icon.classList.remove('is-active');
        }
      }
    }
  });
});

// Close nested dropdowns when leaving the desktop navigation
document.querySelector('desktop-navigation')?.addEventListener('mouseleave', function(event) {
  // Only close if we're actually leaving the navigation area
  if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
    closeAllNestedDropdowns();
  }
});